module.exports = "nav {\n  background: #00A027; }\n  nav .brand-logo {\n    margin-left: 5px;\n    font-size: 120%;\n    color: #fff; }\n  @media (min-width: 1000px) {\n  .menu {\n    display: none; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navbar/navbar.component.scss
// module id = ./src/app/components/navbar/navbar.component.scss
// module chunks = main